import React, { useCallback, useContext } from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';

import { ArchivalAidMetadata } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import {
  addArchivalAidToFavourites,
  removeArchivalAidFromFavourites,
} from 'modules/portfolio-favourite/favourite-api';
import { AuthCtx } from 'components/auth/auth-ctx';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function ArchivalAidFavourite({
  item,
  refreshDetail,
}: GridActionButtonComponent) {
  const classes = useStyles();
  const { userInfo } = useContext(AuthCtx);
  const { showNotification } = useContext(NotificationCtx);

  const archivalAidMetadata = item as ArchivalAidMetadata;

  const isFavourite = Boolean(archivalAidMetadata?.favourite);

  const handleAddToFavourites = useCallback(async () => {
    const response = await addArchivalAidToFavourites(archivalAidMetadata.id);
    if (response.ok) {
      showNotification(
        'Archivní pomůcka byla úspěšně přidána mezi oblíbené.',
        NotificationVariant.SUCCESS
      );
      refreshDetail();
    } else {
      showNotification(
        'Při přidávání archivní pomůcky mezi oblíbené nastala chyba.',
        NotificationVariant.ERROR
      );
    }
  }, [archivalAidMetadata, showNotification, refreshDetail]);

  const handleRemoveFromFavourites = useCallback(async () => {
    const response = await removeArchivalAidFromFavourites(
      archivalAidMetadata.id
    );

    if (response.ok) {
      showNotification(
        'Archivní pomůcka byla úspěšně odebrána z oblíbených.',
        NotificationVariant.SUCCESS
      );
      refreshDetail();
    } else {
      showNotification(
        'Při odebíraní archivní pomůcky z oblíbených nastala chyba.',
        NotificationVariant.ERROR
      );
    }
  }, [archivalAidMetadata, showNotification, refreshDetail]);

  return userInfo?.aisAuthenticated ? (
    <Button
      component="span"
      variant="outlined"
      color="primary"
      className={classes.navigationButton}
      onClick={isFavourite ? handleRemoveFromFavourites : handleAddToFavourites}
    >
      {isFavourite ? 'Odstraň z oblíbených' : 'Přidej k oblíbeným'}
    </Button>
  ) : (
    <></>
  );
}
